import { Form, Radio } from 'antd';
import { dateType } from '../custom-date-selector-list/helpers';
import useAppData from '@/hooks/useAppData';

type Props = {
  name: string;
  //   options: { label: string; value: string }[];
  initialValue?: string;
  onChange: (data: any) => void;
};

export default function RadioButtonGroup({
  name,
  initialValue,
  onChange,
}: Props) {
  const app = useAppData();
  const defaultOptions =
    app?.app?.dateType === 'bs'
      ? [
          { label: 'AD', value: 'ad' },
          { label: 'BS', value: 'bs' },
        ]
      : [];
  return (
    <Form.Item
      name={name}
      noStyle
      initialValue={initialValue}
      hidden={app?.app?.dateType === 'ad'}
    >
      <Radio.Group
        block
        options={defaultOptions}
        optionType="button"
        onChange={onChange}
      />
    </Form.Item>
  );
}
